import React from 'react';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { SearchBox } from '@fluentui/react/lib/SearchBox';
import styles from '../../styles/cr.module.scss';
import { CrCommandBar } from './CrCommandBar';
import { PrimaryButton } from '@fluentui/react';

export interface IListCommandBarProps {
    className?: string;
    onAdd: () => void;
    onAddMultiple?: () => void;
    onEdit: () => void;
    onView?: () => void;
    onDelete: () => void;
    onFilterChange?: (filterText: string) => void;
    addDisabled?: boolean;
    editDisabled?: boolean;
    viewDisabled?: boolean;
    deleteDisabled?: boolean;
    addChildDisabled?: boolean;
    onAddChild?: () => void;
    addChildName?: string;
    additionalItems?: ICommandBarItemProps[];
    additionalItemsOnSelection?: ICommandBarItemProps[];
    additionalFarItems?: ICommandBarItemProps[];
    preFarItems?: ICommandBarItemProps[];
    preFarItemsOnSelection?: ICommandBarItemProps[];
}

export const ListCommandBar = (props: IListCommandBarProps): React.ReactElement => {
    const { className, onAdd, onAddMultiple, onEdit, onView, onDelete, onFilterChange, addDisabled, editDisabled, viewDisabled,
        deleteDisabled, addChildDisabled, onAddChild, addChildName, additionalItems, additionalItemsOnSelection, additionalFarItems, preFarItems, preFarItemsOnSelection } = props;

    const addMultipleItems = onAddMultiple ?
        {
            split: true,
            menuProps: {
                items: [{
                    key: 'newMultiple',
                    text: 'New (multiple reports)',
                    iconProps: { iconName: 'CPlusPlusLanguage' },
                    onClick: onAddMultiple
                }]
            }
        } : {};

    const addItem: ICommandBarItemProps = {
        key: 'new',
        text: 'New',
        iconProps: { iconName: 'Add' },
        onClick: onAdd,
        // onRender: function renderAdd() {
        //     return (
        //         <div className={styles.crCommandBarContainer}>
        //             <div className={styles.crCommandBarPrimaryButton}>
        //                 <PrimaryButton
        //                     text="New"
        //                     iconProps={{ iconName: 'Add' }}
        //                     onClick={onAdd}
        //                     {...addMultipleItems}
        //                 />
        //             </div>
        //         </div>
        //     );
        // }
    };

    const editItem: ICommandBarItemProps = {
        key: 'edit',
        text: 'Edit',
        iconProps: { iconName: 'Edit' },
        onClick: onEdit,
        disabled: editDisabled
    };

    const viewItem: ICommandBarItemProps = {
        key: 'view',
        text: 'View',
        iconProps: { iconName: 'View' },
        onClick: onView,
        //disabled: editDisabled
    };

    const deleteItem = {
        key: 'delete',
        text: 'Delete',
        iconProps: { iconName: 'Delete' },
        onClick: onDelete,
        disabled: deleteDisabled
    };

    const addChildItem: ICommandBarItemProps = {
        key: 'addChild',
        text: `Add ${addChildName}`,
        iconProps: { iconName: 'Add' },
        onClick: onAddChild
    };

    const commandBarItems: ICommandBarItemProps[] = [];

    if (!addDisabled) {
        commandBarItems.push(addItem);
    }
    if (!editDisabled) {
        commandBarItems.push(editItem);
    }
    if (!viewDisabled) {
        commandBarItems.push(viewItem);
    }
    if (!deleteDisabled) {
        commandBarItems.push(deleteItem);
    }
    if (!addChildDisabled && onAddChild && addChildName) {
        commandBarItems.push(addChildItem);
    }
    if (additionalItems) {
        commandBarItems.push(...additionalItems);
    }
    if (additionalItemsOnSelection && !editDisabled) {
        commandBarItems.push(...additionalItemsOnSelection);
    }

    // if (preFarItems || (preFarItemsOnSelection && !editDisabled)) {
    //     const switchItem: ICommandBarItemProps = {
    //         key: 'switch',
    //         text: 'Switch',
    //         iconProps: { iconName: 'Switch' },
    //         subMenuProps: {
    //             items: [
    //                 ...(preFarItems || []), // Spread preFarItems if it exists, otherwise use an empty array
    //                 ...(preFarItemsOnSelection && !editDisabled ? preFarItemsOnSelection || [] : []), // Spread preFarItemsOnSelection if it exists, otherwise use an empty array
    //             ],
    //         },
    //     };

    //     commandBarItems.push(switchItem);
    // }

    if (preFarItems) {
        commandBarItems.push(...preFarItems);
    }

    if (preFarItemsOnSelection && !editDisabled) {
        commandBarItems.push(...preFarItemsOnSelection);
    }


    const farCommandBarItems: ICommandBarItemProps[] = [];

    // if (preFarItems) {
    //     farCommandBarItems.push(...preFarItems);
    // }

    // if (preFarItemsOnSelection && !editDisabled) {
    //     farCommandBarItems.push(...preFarItemsOnSelection);
    // }

    if (onFilterChange) {
        farCommandBarItems.push(
            {
                key: 'filter',
                text: 'List filter',
                inActive: true,
                onRender: function renderFilter() {
                    return (
                        <div className={styles.crCommandBarContainer}>
                            <SearchBox placeholder="Filter items" onChange={(_, v) => onFilterChange(v)} className={styles.listFilterBox} />
                        </div>
                    );
                }
            }
        );
    }



    if (additionalFarItems) {
        farCommandBarItems.push(...additionalFarItems);
    }

    return <CrCommandBar className={className} items={commandBarItems} farItems={farCommandBarItems} />;
};
